// extracted by mini-css-extract-plugin
module.exports = {"seat":"seat-2zxAD","title":"title-vQX0q","seat_business":"seat_business-3m_UT","description":"description-32Fqa","seat__info":"seat__info-DguG4","features":"features-3iZuR"};